import { createContext } from 'react';

import { WorkloadOptimizationState } from '@cast/types';

import {
  ApplyState,
  AutoOptimizationScreen,
  AutoOptimizationWizardState,
  BinPackingFlowState,
  RebalancingPlanFlowState,
  RebalancingScheduleFormState,
} from '../_types';
import {
  EnvironmentType,
  OptimizationGoal,
} from '../open-api-types/autopilot-types';

export type AutoOptimizationContextValue = {
  currentScreen: AutoOptimizationScreen;
  isLoadingScreen: boolean;
  state: AutoOptimizationWizardState;
  rebalancingPlanFlowState: RebalancingPlanFlowState;
  binPackingFlowState: BinPackingFlowState;
  rebalancingScheduleFormState: RebalancingScheduleFormState;
  rebalanceImmediately: boolean;
  startOpsPilot: () => void;
  onClose: () => void;
  onSelectPriority: (priority: OptimizationGoal) => void;
  onSelectEnvironment: (clusterUsage: EnvironmentType) => void;
  onToggleFeature: (feature: 'nodeAutoscaling' | 'workloadAutoscaling') => void;
  onToggleRebalanceOption: () => void;
  onToggleScheduleOption: () => void;
  onUpdateScheduleForm: ({
    cron,
    timeZone,
  }: Pick<RebalancingScheduleFormState, 'cron' | 'timeZone'>) => void;
  onGenerate: () => void;
  onRetryApply: () => void;
  onRetryNodeRebalancePlan: () => void;
  onSetExcludedNamespaces: (namespaces: string[]) => void;
  navigateTo: (screen: AutoOptimizationScreen) => void;
  onBack: () => void;
  backButtonStatus: 'hidden' | 'disabled' | 'default';
  onNext: () => void;
  nextButtonStatus: 'hidden' | 'disabled' | 'default';
  applyState: ApplyState | null;
  onStepClick: (stepIndex: number) => void;
  onReset: () => void;
  onUpdatePolicyManagementOption: (
    policyName: string,
    managementOption: WorkloadOptimizationState
  ) => void;
};

export const AutoOptimizationContext =
  createContext<AutoOptimizationContextValue | null>(null);
